import React, { useEffect } from "react";
import { trackEvent } from "../analytics";

const faqs = [
  {
    question: "What is CSRD reporting?",
    answer:
      "CSRD reporting is the sustainability reporting process required under the Corporate Sustainability Reporting Directive. It requires companies to disclose environmental, social, and governance information using the European Sustainability Reporting Standards (ESRS)."
  },
  {
    question: "Who needs to comply with CSRD?",
    answer:
      "Large EU companies, listed SMEs, and many non-EU companies with significant EU activity may be required to comply with CSRD. Suppliers may also be indirectly affected through customer reporting requirements."
  },
  {
    question: "What is a double materiality assessment?",
    answer:
      "A double materiality assessment evaluates both how sustainability issues impact a company financially and how the company impacts people, society, and the environment."
  },
  {
    question: "What are ESRS standards?",
    answer:
      "European Sustainability Reporting Standards (ESRS) provide the framework companies use to prepare sustainability disclosures under CSRD."
  },
  {
    question: "Can AI help with ESG reporting?",
    answer:
      "Yes. AI can help identify reporting gaps, organize evidence, draft disclosures, summarize data, and improve reporting efficiency. Human review remains essential."
  },
  {
    question: "How does Ecovanta help with ESG reporting?",
    answer:
      "Ecovanta helps organizations collect ESG data, perform materiality assessments, identify disclosure gaps, generate AI-assisted reporting drafts, and prepare investor-ready sustainability reports."
  },
  {
    question: "Does Ecovanta support CSRD readiness assessments?",
    answer:
      "Yes. Ecovanta includes readiness assessment tools, materiality workflows, benchmarking, analytics, AI drafting, and reporting capabilities."
  },
  {
    question: "Can I export reports to PDF?",
    answer:
      "Yes. Depending on your subscription plan, Ecovanta allows ESG and sustainability reports to be exported as professional PDF documents."
  }
];

export default function FAQPage() {
  useEffect(() => {
    trackEvent("resource_view", {
      resource: "faq",
      path: window.location.pathname
    });
  }, []);

  const handleDemoClick = () => {
    trackEvent("demo_click", {
      source: "faq",
      path: window.location.pathname
    });

    window.location.href =
      "mailto:hello@onedigitale.com?subject=Ecovanta Demo Request";
  };

  return (
    <main
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "64px 24px",
        fontFamily:
          'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
      }}
    >
      <a
        href="/"
        style={{
          textDecoration: "none",
          color: "#475569",
          fontWeight: 700
        }}
      >
        ← Back to Ecovanta
      </a>

      <div
        style={{
          marginTop: "32px",
          color: "#047857",
          fontWeight: 900,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          fontSize: "13px"
        }}
      >
        Frequently Asked Questions
      </div>

      <h1
        style={{
          fontSize: "clamp(36px, 5vw, 64px)",
          lineHeight: 1.05,
          marginTop: "16px",
          marginBottom: "20px"
        }}
      >
        CSRD, ESG Reporting & Ecovanta FAQ
      </h1>

      <p
        style={{
          fontSize: "20px",
          lineHeight: 1.7,
          color: "#475569",
          maxWidth: "900px"
        }}
      >
        Find answers to common questions about CSRD compliance,
        ESG reporting, ESRS standards, AI-assisted sustainability reporting,
        and how Ecovanta helps organizations prepare investor-ready disclosures.
      </p>

      <div
        style={{
          marginTop: "48px",
          display: "grid",
          gap: "20px"
        }}
      >
        {faqs.map((item) => (
          <div
            key={item.question}
            style={{
              background: "#ffffff",
              border: "1px solid #e2e8f0",
              borderRadius: "20px",
              padding: "24px",
              boxShadow: "0 8px 24px rgba(15,23,42,0.05)"
            }}
          >
            <h2
              style={{
                marginTop: 0,
                marginBottom: "12px",
                fontSize: "22px"
              }}
            >
              {item.question}
            </h2>

            <p
              style={{
                margin: 0,
                lineHeight: 1.8,
                color: "#475569"
              }}
            >
              {item.answer}
            </p>
          </div>
        ))}
      </div>

      <section
        style={{
          marginTop: "64px",
          background: "#0f172a",
          color: "#ffffff",
          borderRadius: "24px",
          padding: "36px"
        }}
      >
        <h2>Ready to simplify ESG reporting?</h2>

        <p
          style={{
            lineHeight: 1.8,
            color: "#cbd5e1"
          }}
        >
          Ecovanta helps organizations streamline ESG data collection,
          identify reporting gaps, generate AI-assisted disclosures,
          and prepare CSRD-ready sustainability reports.
        </p>

        <button
          onClick={handleDemoClick}
          style={{
            marginTop: "16px",
            border: "none",
            background: "#10b981",
            color: "#ffffff",
            padding: "14px 20px",
            borderRadius: "12px",
            fontWeight: 800,
            cursor: "pointer"
          }}
        >
          Book a Demo
        </button>
      </section>
    </main>
  );
}